// src/components/Navbar.js
import { NavLink } from 'react-router-dom';
import Logo from '../assets/images/sk-logo.png';

function Navbar() {
    // Función para decodificar el JWT
    const decodeJWT = (token) => {
        try {
            const base64Url = token.split('.')[1]; // Obtener el payload
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Reemplazar caracteres especiales
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload); // Convertir a objeto JavaScript
        } catch (error) {
            console.error('Error decodificando el JWT:', error);
            return null;
        }
    };

    // Obtener el authtoken desde el localStorage
    const authToken = localStorage.getItem('authToken');

    // Decodificar el JWT y extraer el menú
    const decodedToken = authToken ? decodeJWT(authToken) : null;
    const menu = decodedToken?.menu || []; // Extraer el menú o usar un array vacío si no existe

    const cerrarSesion = () => {
        localStorage.clear(); // Limpiar el localStorage
        window.location.href = '/'; // Redirigir al inicio
    };

    // Función para generar los elementos del menú
    const renderMenu = (menuItems) => {
        return menuItems.map((item) => {
            if (item.children && item.children.length > 0) {
                return (
                    <li className="nav-item dropdown" key={item.id}>
                        <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            id={`nav-${item.id}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {item.name}
                        </a>
                        <ul className="dropdown-menu" aria-labelledby={`nav-${item.id}`}>
                            {renderMenu(item.children)}
                        </ul>
                    </li>
                );
            } else {
                return (
                    <li key={item.id}>
                        <NavLink to={item.path} className="dropdown-item">
                            {item.name}
                        </NavLink>
                    </li>
                );
            }
        });
    };

    return (
        <nav className="navbar navbar-expand-sm shadow-sm" aria-label="Third navbar example">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img src={Logo} alt="SK Logo" className="nav-logo" />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto mb-2 mb-sm-0">
                        {renderMenu(menu)}
                    </ul>
                    {/* Botón de Cerrar Sesión */}
                    <ul className="navbar-nav mb-2 mb-sm-0">
                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={cerrarSesion}>
                                Cerrar Sesión
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;